import { useQuery } from "@apollo/client";
import { FIND_MATTER } from "~/graphql/query";

type UseFindMatterQueryProps = {
  id: number;
  version?: number;
  skip?: boolean;
};

export const useFindMatterQuery = ({ id: matterId, skip }: UseFindMatterQueryProps) => {
  const { ...rest } = useQuery(FIND_MATTER, {
    variables: { id: matterId },
    skip,
  });

  return {
    ...rest,
  };
};
